import styled from 'styled-components'

export const Container = styled.ul`
  display: grid;
  gap: 2px;
  flex-direction: column;

  & + & {
    margin-top: 48px;
  }
`
